import * as actions from './actions'
import * as types from './mutation-types'

const state = {
  eventTypes:[],
  getEventTypesError: '',
  getEventTypesLoading: false,
  calendarEvents:[],
  getEventsError: '',
  getEventsLoading: false,
  deletedEvent: {},
  deleteEventError: '',
  deleteEventLoading: false
}

const getters = {
  eventTypes: state => state.eventTypes,
  getEventTypesError: state => state.getEventTypesError,
  getEventTypesLoading: state => state.getEventTypesLoading,
  calendarEvents: state => state.calendarEvents,
  getEventsError: state => state.getEventsError,
  getEventsLoading: state => state.getEventsLoading,
  deletedEvent: state => state.deletedEvent,
  deleteEventError: state => state.deleteEventError,
  deleteEventLoading: state => state.deleteEventLoading
}

const mutations = {
  [types.GET_EVENT_TYPES_REQUEST] (state){
    state.getEventTypesLoading = true;
    state.eventTypes = [];
    state.getEventTypesError = {};
  },
  [types.GET_EVENT_TYPES_SUCCESS] (state, eventTypes){
    state.getEventTypesLoading = false;
    state.eventTypes = eventTypes;
    state.getEventTypesError = {};
  },
  [types.GET_EVENT_TYPES_FAILURE] (state, error){
    state.getEventTypesLoading = false;
    state.eventTypes = [];
    state.getEventTypesError = error;
  },
  [types.GET_EVENTS_REQUEST] (state){
    state.getEventsLoading = true;
    state.calendarEvents = [];
    state.getEventsError = {};
  },
  [types.GET_EVENTS_SUCCESS] (state, calendarEvents){
    state.getEventsLoading = false;
    state.calendarEvents = calendarEvents;
    state.getEventsError = {};
  },
  [types.GET_EVENTS_FAILURE] (state, error){
    state.getEventsLoading = false;
    state.calendarEvents = [];
    state.getEventsError = error;
  },
  [types.DELETE_EVENT_REQUEST] (state){
    state.deleteEventLoading = true;
    state.deletedEvent = {};
    state.deleteEventError = '';
  },
  [types.DELETE_EVENT_SUCCESS] (state, deletedEvent){
    state.deleteEventLoading = false;
    state.deletedEvent = deletedEvent;
    state.deleteEventError = '';
  },
  [types.DELETE_EVENT_FAILURE] (state, error){
    state.deleteEventLoading = false;
    state.deletedEvent = {};
    state.deleteEventError = error;
  },
}

export default {
  state,
  actions,
  getters,
  mutations
}
